<template>
  <b-container>
    <b-row class="vh-100 text-center" align-v="center">
      <b-col md="4" offset-md="4">
        <b-form ref="requestResetForm" @submit.stop.prevent="handleForm">
          <my-input id="my-name" name="my-name" mandatory="true" :placeholder="$t(LangConstants.email_input_placeholder)" inlinerows="false" variant="test" ref="email"></my-input>
          <my-button type="submit" :label="$t(LangConstants.send_password_reset_link_button_label)" variant="box-general" classes="" height="56px" width="90%"></my-button>

          <my-button fa="" :label="$t(LangConstants.back_to_login_button_label)" variant="link" classes="btn-link" height="48px" width="200px" @onClick="$router.push('login')"></my-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import MyInput from "../../components/atoms/Input.vue";
import MyButton from "../../components/atoms/Button.vue";
import Constants from "../../constants/index";
/**
 * Password Request Page
 */
export default {
  name: "request-password-reset",

  mounted() {},

  created() {},

  data() {
    return {};
  },

  computed: {
    LangConstants() {
      return Constants;
    },
  },
  methods: {
    handleForm() {
      const email = this.$refs.email.text;
      console.log(email);
    },
  },
  components: {
    MyInput,
    MyButton,
  },
};
</script>
